import { configureStore } from '@reduxjs/toolkit';
import uiReducer from 'redux/features/ui-slice';
import globalDataReducer from 'redux/features/globalData-slice';
import { useSelector as originalUseSelctor, TypedUseSelectorHook } from 'react-redux';
import geofiltersReducer from 'redux/features/geo-filters-slice';


export const store = configureStore({
  reducer: {
    ui: uiReducer,
    globalData: globalDataReducer,
    geofilters: geofiltersReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>

export const useSelector: TypedUseSelectorHook<RootState> = originalUseSelctor;
